// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ou-c";
export var backButton = "_ou-4";
export var backIcon = "_ou-5";
export var chevronShortcut = "_ou-6";
export var container = "_ou-1";
export var editor = "_ou-8";
export var editorWrapper = "_ou-7";
export var prefix = "_ou-2";
export var searchIcon = "_ou-3";
export var suffix = "_ou-9";
export var suffixContent = "_ou-a";
export var suffixText = "_ou-b";
export var wrapper = "_ou-0";